// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar_nav {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  overflow: scroll;
}
.navbar {
  position: fixed;
  background-color: var(--ColorSecondary);
  transition: width 200ms ease;
  border-radius: 0;
  z-index: 1;
}
.nav_item {
  width: 100%;
  margin: 1.5rem;
  margin-left: 4.2rem;
}
.nav_item a:hover{
  text-decoration: none;
}
.nav_link {
  display: flex;
  align-items: center;
  height: 5rem;
  text-decoration: none;
}
.link_text {
    display: none;
  }
/***************************************Ecras Grandes (PCs)***************************************/
@media only screen and (min-width: 600px) {
  
  .nav_item:last-child {
    margin-top: auto;
  }

  .nav_link img {
    min-width: 2rem;
    margin: 0;
    transition: 200ms ease;
  }

  .logo_container {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    
  }
  .logo {
    margin-bottom: 0;
  }
  .logo img {
    transition: 200ms ease;
  }
  .second_logo {
    margin: 0;
  }
  .second_logo img {
    display: none;
  }
  .navbar {
    top: 0;
    width: 6rem;
    height: 100vh;
  }
  .navbar:hover {
    width: 25rem;
  }
  .navbar:hover ~ body, .navbar:hover ~ .body_main {
    margin-left: 27rem;
    transition: 200ms;
  }
  .navbar:hover .link_text {
    display: block;
    color: var(--ColorPrimary);
    margin-left: 1.5rem;
    transition: 200ms ease;
  }
  .navbar:hover .logo img {
    display: none;
    transition: 200ms ease;
  }
  .navbar:hover .logo_container .second_logo img {
    display: block;
    width: 150px;
    margin: 0;
    
  }
}
/***************************************Ecras pequenos (SmartPhones)***************************************/
@media only screen and (max-width: 600px) {
  .navbar + .body_main {
    margin-bottom: 7rem;
  }
  .nav_item:last-child {
    display: none;
  }
  .nav_link:hover,
  .nav_link:active {
    background-color: #af6565ce;
    border-radius: 100%;
    height: 40px;
    width: 40px;
  }
  .navbar_nav {
    flex-direction: row;
  }
  .navbar {
    bottom: 0;
    width: 100vw;
    height: 5rem;
    margin: 0;
  }
  .nav_link {
    justify-content: center;
    transition: 200ms ease;
  }
  .logo_container {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/navbar/navbar.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,uCAAuC;EACvC,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;AACA;IACI,aAAa;EACf;AACF,kGAAkG;AAClG;;EAEE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;EAErB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,MAAM;IACN,WAAW;IACX,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,0BAA0B;IAC1B,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,YAAY;IACZ,SAAS;;EAEX;AACF;AACA,2GAA2G;AAC3G;EACE;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;;IAEE,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,SAAS;EACX;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".navbar_nav {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n  overflow: scroll;\n}\n.navbar {\n  position: fixed;\n  background-color: var(--ColorSecondary);\n  transition: width 200ms ease;\n  border-radius: 0;\n  z-index: 1;\n}\n.nav_item {\n  width: 100%;\n  margin: 1.5rem;\n  margin-left: 4.2rem;\n}\n.nav_item a:hover{\n  text-decoration: none;\n}\n.nav_link {\n  display: flex;\n  align-items: center;\n  height: 5rem;\n  text-decoration: none;\n}\n.link_text {\n    display: none;\n  }\n/***************************************Ecras Grandes (PCs)***************************************/\n@media only screen and (min-width: 600px) {\n  \n  .nav_item:last-child {\n    margin-top: auto;\n  }\n\n  .nav_link img {\n    min-width: 2rem;\n    margin: 0;\n    transition: 200ms ease;\n  }\n\n  .logo_container {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    \n  }\n  .logo {\n    margin-bottom: 0;\n  }\n  .logo img {\n    transition: 200ms ease;\n  }\n  .second_logo {\n    margin: 0;\n  }\n  .second_logo img {\n    display: none;\n  }\n  .navbar {\n    top: 0;\n    width: 6rem;\n    height: 100vh;\n  }\n  .navbar:hover {\n    width: 25rem;\n  }\n  .navbar:hover ~ body, .navbar:hover ~ .body_main {\n    margin-left: 27rem;\n    transition: 200ms;\n  }\n  .navbar:hover .link_text {\n    display: block;\n    color: var(--ColorPrimary);\n    margin-left: 1.5rem;\n    transition: 200ms ease;\n  }\n  .navbar:hover .logo img {\n    display: none;\n    transition: 200ms ease;\n  }\n  .navbar:hover .logo_container .second_logo img {\n    display: block;\n    width: 150px;\n    margin: 0;\n    \n  }\n}\n/***************************************Ecras pequenos (SmartPhones)***************************************/\n@media only screen and (max-width: 600px) {\n  .navbar + .body_main {\n    margin-bottom: 7rem;\n  }\n  .nav_item:last-child {\n    display: none;\n  }\n  .nav_link:hover,\n  .nav_link:active {\n    background-color: #af6565ce;\n    border-radius: 100%;\n    height: 40px;\n    width: 40px;\n  }\n  .navbar_nav {\n    flex-direction: row;\n  }\n  .navbar {\n    bottom: 0;\n    width: 100vw;\n    height: 5rem;\n    margin: 0;\n  }\n  .nav_link {\n    justify-content: center;\n    transition: 200ms ease;\n  }\n  .logo_container {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
